import { useCallback, useRef, useState, type ChangeEvent, type ReactNode } from 'react'

import { useSelectButtonEvent, useSelectFieldEvent } from '@/legacy/core/analytics/hooks'

import { sanitizeText } from '@/legacy/core/analytics/utils/sanitize'

import { order, type OrderValues, type PartnersListProps } from '../types'

import { PartnerSearchContext } from './PartnerSearchContext'

interface PartnerSearchProviderProps extends PartnersListProps {
  children: ReactNode
}
export function stringTreatment(string: string) {
  return sanitizeText(string.toLowerCase()).replace(/-/g, '')
}

export const PartnerSearchProvider = ({
  items,
  settingsLink,
  title,
  subtitle,
  cardButtonLabel,
  concatenation,
  children,
}: PartnerSearchProviderProps) => {
  const [inputSearchPartner, setInputSearchPartner] = useState('')
  const [expanded, setExpanded] = useState(false)
  const [checkedValue, setChecked] = useState<OrderValues>(order.relevance)

  const [shouldEnableNotifier, setShouldEnableNotifier] = useState<boolean>(false)
  const divRef = useRef<HTMLDivElement>(null)

  const selectFieldEvent = useSelectFieldEvent()
  const selectButtonEvent = useSelectButtonEvent()

  const handleSearchInput = (event: ChangeEvent<HTMLInputElement>) => {
    setShouldEnableNotifier(false)
    setInputSearchPartner(event.target.value)
  }

  const searchValue = stringTreatment(inputSearchPartner)
  const filterParters = items.filter((item) =>
    item.name ? stringTreatment(item.name).includes(searchValue) : item,
  )

  const sortedPartners = [...filterParters].sort((a, b) => {
    if (!a.name || !b.name) return 0

    if (checkedValue === order.alphabeticalAZ) {
      return a.name.localeCompare(b.name)
    }
    if (checkedValue === order.alphabeticalZA) {
      return b.name.localeCompare(a.name)
    }
    return 0
  })

  const handleOptionChange = (
    event: ChangeEvent<HTMLInputElement> & React.KeyboardEvent & React.MouseEvent<HTMLInputElement>,
  ) => {
    const isMouseEvent = event.clientX !== 0
    if (!isMouseEvent) return

    setChecked(event.target.value as OrderValues)
    selectButtonEvent({ label: `ordenar-por-${checkedValue}` })
    toggleExpansion()
  }

  const toggleExpansion = useCallback(() => {
    setExpanded(!expanded)
    if (expanded) {
      setShouldEnableNotifier(true)
    }
  }, [expanded])

  const handleKeyPressDown = (event: React.KeyboardEvent) => {
    if (event.code !== 'Enter') return setShouldEnableNotifier(false)
    selectFieldEvent({ label: 'busque-pelo-parceiro' })
    return setShouldEnableNotifier(true)
  }

  return (
    <PartnerSearchContext.Provider
      value={{
        title,
        subtitle,
        concatenation,
        cardButtonLabel,
        settingsLink,
        toggleExpansion,
        handleKeyPressDown,
        handleOptionChange,
        handleSearchInput,
        divRef,
        shouldEnableNotifier,
        checkedValue,
        expanded,
        inputSearchPartner,
        sortedPartners,
      }}
    >
      {children}
    </PartnerSearchContext.Provider>
  )
}
